<template>
    <div>
        <notification-container :notifications="notifications" />
        <toggle-button
            v-bind="{color, labels, sync, value, width}"
            @input="sendRequest"
            :disabled="disabled"
        ></toggle-button>
    </div>
</template>

<script>
import NotificationContainer from "../../Common/NotificationContainer.vue";
import notificationsMixin from "../../../mixins/notifications.js";

export default {
    name: 'ApiToggleButton',

    props: {
        color: {
            type: Object,
            default: () => ({
                checked: '#57b759',
                unchecked: '#9a9a9a',
            }),
        },
        endpoint: {
            type: String,
            required: false,
        },
        fieldName: {
            type: String,
            required: false,
        },
        labels: {
            type: Object,
            default: () => ({
                checked: 'Enabled',
                unchecked: 'Disabled',
            }),
        },
        startValue: {
            type: Boolean,
            required: true,
        },
        sync: {
            type: Boolean,
            default: false,
        },
        width: {
            type: Number,
            default: 100,
        },
        config: {
            type: Object,
            default: () => ({}),
            required: false,
        },
        authenticationType: {
            type: String,
            default: 'session',
            required: false,
            validator: value => ['jwt', 'api_token', 'session'].includes(value),
        },
        reloadOnSuccess: {
            type: Boolean,
            default: false,
            required: false,
        },
    },
    components: {
        NotificationContainer,
    },
    mixins: [notificationsMixin],
    data() {
        return {
            value: this.startValue,
            disabled: false,
        }
    },

    watch: {
        value(newVal) {
            this.$emit('input', newVal);
        },
    },

    methods: {
        sendRequest() {
            const fieldValue = !this.value;
            const requestData = this.fieldName ? {[this.fieldName]: fieldValue} : {};
            this.disabled = true;

            this.makeRequest(requestData)
                .then((response) => {
                    this.disabled = false;
                    if (this.isSuccessResponse(response.data)) {
                        this.value = fieldValue;

                        if (this.reloadOnSuccess) {
                            window.location.reload()
                        }

                        return;
                    }

                    this.value = !fieldValue;
                    this.showAlertMessage('Something went wrong. Please contact support.', 'error');
                })
                .catch(error => {
                    this.disabled = false;
                    this.value = !fieldValue;
                    this.showAlertMessage('Something went wrong. Please contact support.', 'error');
                    console.log('API request failed:', error);
                });
        },

        makeRequest(requestData) {
            if (this.authenticationType.toLowerCase() === 'jwt') {
                return this.$root.makeApiRequest((jwtToken) => {
                    return axios.put(this.endpoint, requestData, {
                        headers: {
                            'Authorization': jwtToken,
                            'Accept': 'application/json'
                        }
                    });
                });
            }

            if (this.authenticationType.toLowerCase() === 'api_token') {
                if (!this.config.headers || !this.config.headers.token) {
                    this.showAlertMessage('Authentication token is missing. Please contact support.', 'error');
                    return Promise.reject(new Error('API token not found in config headers'));
                }
            }

            return axios.put(this.endpoint, requestData, {...this.config});
        },

        isSuccessResponse(responseData) {
            if (['jwt', 'api_token'].includes(this.authenticationType.toLowerCase())) {
                return responseData.status === 'success';
            }

            return responseData.success === true;
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/Utility/Buttons/ApiToggleButton.vue